import styled from "styled-components";

const StyledButton = styled.button`
  background: transparent;
  border: none;
  border-radius: 0;
  text-decoration: underline;
  font-weight: bold;
  color: black;
  text-transform: none;
  letter-spacing: unset;
  padding: 0;
  height: unset;
  min-height: unset;
  box-shadow: none;
  text-underline-offset: 4px;

  &:active {
    box-shadow: none;
  }

  &:hover {
    color: #000081;
  }
`;

export default StyledButton;
